import { useSelector } from 'react-redux';
import { RootState } from '../store/indexRedux';

export const useRoles = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const role = user?.role || '';
  const roles: string[] = user?.roles || [];

  const hasRole = (target: string) => role === target || roles.includes(target);

  const isAdmin = hasRole('admin');
  const isPartner = hasRole('partner') || hasRole('my-services-partner');
  const isAdminOrPartner = isAdmin || isPartner;

  return { isAdmin, isPartner, isAdminOrPartner };
};
